<wiz-vgroup width="100%" height="100%" class="section-container">
  <wiz-hgroup
    width="100%"
    height="20px"
    verticalAlign="center"
    padding="3px"
    gap="2"
    class="background-title"
  >
    <wiz-label #lbTitle width="100%" class="componentLabel" [wizLabel]="'$.formula.add.function.$'"></wiz-label>
    <wiz-icon (click)="doCancel()">close</wiz-icon>
  </wiz-hgroup>

  <wiz-vgroup width="100%" height="100%">
    <wiz-hgroup width="100%" height="100%">
      <multi-display  
      code="addFunctionMD" width="100%" height="100%" 
      [config]="tileDisplayConfig" ></multi-display>
    </wiz-hgroup>

    <wiz-hgroup width="100%" height="80px">
      <div
        #descDiv
        spellcheck="false"
        width="100%"
        height="100%"
        class="formula-div"
        [innerHtml]="currentDescHtml"
        style="overflow-y: auto"
      ></div>
    </wiz-hgroup>
  </wiz-vgroup>

  <wiz-hgroup width="100%" padding="5px">
    <filter-component #functionFilter width="200px"> </filter-component>
    <wiz-spacer width="100%"></wiz-spacer>
    <wiz-button
      #btnSave
      (click)="save($event)"
      [wizLabel]="'$.formula.add.function.$'"
      [wizIcon]="'icon-arrow-right'"
      [iconPlacement]="'right'"
      width="150px"
    ></wiz-button>
    <wiz-button
      #btnCancel
      (click)="doCancel()"
      class="cancel-button"
      [wizIcon]="'icon-arrow-left'"
      [wizLabel]="'$.common.cancel.$'"
      width="100px"
    ></wiz-button>
  </wiz-hgroup>
</wiz-vgroup>
